import tinycolor from 'tinycolor2';

/**
 * Утилиты для работы с цветом
 */
export class bColor {
    /**
     * Возвращает true, если цвет темный
     * @param hex
     */
    public static isDark(hex: string) {
        return tinycolor(hex).getBrightness() < 150;
    }

    /**
     * Возвращает цвет ярче
     * @param hex
     * @param percent
     */
    public static getBrighter(hex: string, percent: number) {
        // strip the leading # if it's there
        const color = hex.replace(/^\s*#|\s*$/g, '');

        let r = parseInt(color.substr(0, 2), 16);
        let g = parseInt(color.substr(2, 2), 16);
        let b = parseInt(color.substr(4, 2), 16);

        if (r <= 0) r = 10;
        if (g <= 0) g = 10;
        if (b <= 0) b = 10;

        return (
            '#' +
            Math.min(255, Math.floor(r * percent)).toString(16) +
            Math.min(255, Math.floor(g * percent)).toString(16) +
            Math.min(255, Math.floor(b * percent)).toString(16)
        );
    }
}
import tinycolor from 'tinycolor2';

/**
 * Утилиты для работы с цветом
 */
export class bColor {
    /**
     * Возвращает true, если цвет темный
     * @param hex
     */
    public static isDark(hex: string) {
        return tinycolor(hex).getBrightness() < 150;
    }

    /**
     * Возвращает цвет ярче
     * @param hex
     * @param percent
     */
    public static getBrighter(hex: string, percent: number) {
        // strip the leading # if it's there
        const color = hex.replace(/^\s*#|\s*$/g, '');

        let r = parseInt(color.substr(0, 2), 16);
        let g = parseInt(color.substr(2, 2), 16);
        let b = parseInt(color.substr(4, 2), 16);

        if (r <= 0) r = 10;
        if (g <= 0) g = 10;
        if (b <= 0) b = 10;

        return (
            '#' +
            Math.min(255, Math.floor(r * percent)).toString(16) +
            Math.min(255, Math.floor(g * percent)).toString(16) +
            Math.min(255, Math.floor(b * percent)).toString(16)
        );
    }
}
